import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/envelope': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM464 112V152.8C441.6 171.1 405.8 199.5 329.4 259.3 312.6 272.5 279.2 304.4 256 304 232.8 304.4 199.4 272.5 182.6 259.3 106.2 199.5 70.4 171.1 48 152.8V112H464zM48 400V214.4C70.9 232.6 103.4 258.3 152.9 297 174.8 314.2 213.1 352.2 256 352 298.7 352.2 336.5 314.8 359.1 297.1 408.6 258.3 441.1 232.7 464 214.4V400H48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/envelope.js
// module id = k98n
// module chunks = 144